import { render } from "./Creditnote.vue?vue&type=template&id=16bd1364"
import script from "./Creditnote.vue?vue&type=script&lang=js"
export * from "./Creditnote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__